module.exports = new __parcel__URL__("shop_little_lemon_friends_image.5915d93b.png").toString();